import { css } from "styled-components";
import token from "styled-token";
import { typographyMixin } from "../typographyMixin";
import { ListboxOptionMixin } from "./ListboxOptionMixin";
import { StyledListboxOptionMedia } from "../../components/Listbox/ListboxOptionMedia";
import { VisuallyHiddenMixin } from "./VisuallyHiddenMixin";
export var ListboxGroupLabelMixin = function ListboxGroupLabelMixin(props) {
  return token({
    fontType: "ListboxGroupLabel.fontType",
    fontColor: "ListboxGroupLabel.fontColor",
    backgroundColor: "ListboxGroupLabel.backgroundColor"
  }, function (tokens) {
    return css(["", " ", " cursor:default;text-transform:uppercase;background-color:", ";&,", "{color:", ";}", ""], ListboxOptionMixin(props), typographyMixin(Object.assign({
      fontType: tokens.fontType
    }, props)), tokens.backgroundColor, StyledListboxOptionMedia, tokens.fontColor, props.visuallyHidden ? VisuallyHiddenMixin(props) : "");
  })(props);
};